// extracted by mini-css-extract-plugin
module.exports = {"innerSection":"About_innerSection__2EkHm","bgChange":"About_bgChange__2XyHh","content":"About_content__1eItL"};